// extracted by mini-css-extract-plugin
export default {"DashboardLoading":"DashboardLoading_DashboardLoading__MOc0D"};